import { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import DropdownToggle from './DropdownToggle'
import FromToInputSuffix from './FromToInputSuffix'
import { itemsFetchData } from '../../redux/items'
import { parseSubjectsFromUrl, removeYearFromSubjects } from '../../SearchUtils'
import { createDropdown, whenBootstrapReady } from '../../../helpers/bootstrap'

function FromToFilter({ name, title, inputSuffix, validation }) {
  const { currentFilters } = useSelector((state) => state.items)
  const dispatch = useDispatch()

  const [form, setForm] = useState({
    from: '',
    to: '',
    priceOnRequest: false,
  })

  const dropdownRef = useRef(null)

  useEffect(() => {
    const dropdownToggleEl = document.getElementById(`dropdown-filter-${name}`)
    return whenBootstrapReady(() => {
      dropdownRef.current = createDropdown(dropdownToggleEl)
    })
  }, [])

  const handleInputChange = (e, kind) => {
    if (/^\d+$/.test(e.target.value) || e.target.value === '') {
      setForm({
        ...form,
        [kind]: e.target.value,
      })
    }
  }

  const isFormValid = () => {
    if (validation == null) return true

    return (
      (form.from >= validation.from || !form.from) &&
      (form.from <= validation.to || !form.from) &&
      form.to <= validation.to &&
      (+form.to >= +form.from || !form.to || !form.from)
    )
  }

  const handleSubmit = () => {
    const currentSubjects = parseSubjectsFromUrl()
    const filters = { ...currentFilters }

    if (name === 'price' && form.priceOnRequest) {
      filters.price = 'por'
    } else if (form.from || form.to) {
      filters[name] = {}
      if (form.from) {
        filters[name].from = form.from
      }
      if (form.to) {
        filters[name].to = form.to
      }
    }

    filters.popstate = 0
    filters.subjects =
      name === 'year'
        ? removeYearFromSubjects(currentSubjects)
        : currentSubjects

    delete filters.page

    setForm({
      ...form,
      from: '',
      to: '',
    })

    dropdownRef.current?.toggle()

    dispatch(itemsFetchData({ filters }))
  }

  return (
    <div className="dropdown d-block">
      <DropdownToggle name={name} title={title} />

      <div
        className="dropdown-menu w-100 p-2"
        aria-labelledby={`dropdown-filter-${name}`}
        id={`dropdown-menu-filter-${name}`}
      >
        <div>
          <label>{title}</label>

          <div className="mb-3">
            <div className="input-group">
              <input
                type="text"
                maxLength={name === 'year' ? '4' : null}
                className="form-control"
                placeholder={I18n.t('from')}
                value={form.from}
                onChange={(e) => handleInputChange(e, 'from')}
                onKeyPress={(e) => {
                  // eslint-disable-next-line no-unused-expressions
                  e.key === 'Enter' && handleSubmit()
                }}
                disabled={form.priceOnRequest}
              />
              {inputSuffix && <FromToInputSuffix inputSuffix={inputSuffix} />}
            </div>
          </div>

          <div className="mb-3">
            <div className="input-group">
              <input
                type="text"
                maxLength={name === 'year' ? '4' : null}
                className="form-control"
                placeholder={I18n.t('to')}
                value={form.to}
                onChange={(e) => handleInputChange(e, 'to')}
                onKeyPress={(e) => {
                  // eslint-disable-next-line no-unused-expressions
                  e.key === 'Enter' && handleSubmit()
                }}
                disabled={form.priceOnRequest}
              />
              {inputSuffix && <FromToInputSuffix inputSuffix={inputSuffix} />}
            </div>
          </div>

          {name === 'price' && (
            <div className="mb-3">
              <div className="checkbox">
                <input
                  type="checkbox"
                  value={form.priceOnRequest}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      priceOnRequest: e.target.checked,
                    })
                  }
                  id="por"
                />
                <label htmlFor="por" className="form-check-label ms-1">
                  {' '}
                  {I18n.t('price_on_request')}
                </label>
              </div>
            </div>
          )}

          <button
            className="btn btn-primary d-block mt-2 w-100"
            type="button"
            onClick={handleSubmit}
            disabled={!form.priceOnRequest && !isFormValid()}
          >
            Submit
          </button>
          {!isFormValid() && (
            <p className="text-danger" style={{ margin: 0 }}>
              {I18n.t('from')} {validation.from} {I18n.t('to')} {validation.to}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default FromToFilter
